import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { city } from 'src/app/shared/classes/city';
// import {ToastrComponent} from 'src/app/shared/components/toastr-component/toastr-component.component';
import {ToastrService} from 'ngx-toastr';
import { takeUntil } from 'rxjs/operators';
import {Subject} from 'rxjs';
import { Country } from 'src/app/shared/classes/Country';
import { cityView } from 'src/app/shared/classes/cityView';
import { DataContextService } from 'src/app/shared/services/data-context.service';
import { CitiesService } from 'src/app/shared/services/cities.service';
import { ConstantsService } from 'src/app/shared/services/Constants/constants.service';
import { MasterService } from 'src/app/shared/services/master.service';
import { AuditData, AuditTrail } from 'src/app/shared/classes/AuditTrail';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { TrackerOmnitureService } from 'src/app/shared/services/tracker-omniture.service';

@Component({
  selector: 'app-edit-city',
  templateUrl: './edit-city.component.html',
  styleUrls: ['../add-city/add-city.component.less']
})
export class EditCityComponent implements OnInit, OnDestroy {

  public cityData: city[] = [];
  public CountryData: Country[] = [];
  CountrySelected:number;
  selectedCountry:string;
  CitySelected: number;
  CityName : string;
  countryName : string;
  MasterList: any;
  CityList:any;
  selectedCity : any;
  CityId:number;
  cityID:number;
  OfficeId : number;
  selectedCityId : any;
  OfficeName: string;
  city:any;
  Status:any;
  cityView:cityView;
  selectActiveStatus: {isChecked: boolean} = {isChecked : false};
  selectInActiveStatus: {isChecked: boolean} = {isChecked : false};
  oldValues: any = [];
  newValues: any = [];
  auditResult: AuditTrail = new AuditTrail();
  
  private service_URL: any;
  private unsubscribe$ =new Subject<void>();
  constructor(
    private _dataContextService : DataContextService,
    private _masterService: MasterService,
    public modalRef:BsModalRef,
    private toast : ToastrService,
    private http:HttpClient,
    private trackeromnitureservice:TrackerOmnitureService,
    // private officeService: OfficesService,
    private citiesService: CitiesService,
     )
    { 
      this.service_URL = ConstantsService; 
    }

  ngOnInit() {
    var username = localStorage.getItem('email');
    username = username.split('@')[0];
    this.trackeromnitureservice.trackPageloadData('city-edit',username);
    this.trackeromnitureservice.trackPage("pageView");

    this.getData();
    // console.log(this.selectedCity)
    this.cityID = this.selectedCity.cityID;
    
    this.CityName = this.selectedCity.cityName;
    this.countryName = this.selectedCity.countryName;

    if(this.selectedCity.isActive){
        this.selectActiveStatus.isChecked=true;
    }
    else{
      this.selectInActiveStatus.isChecked=true;
    }

    // setTimeout(() => {
    //   //Add Countries to CountryData List
    //   for(var i=0;i<this.MasterList.length;i++){
    //     var _cd = new Country();
    //     _cd.countryId = this.MasterList[i].countryID;
    //     _cd.countryName = this.MasterList[i].countryName;

    //     this.CountryData.push(_cd);
    //   }
      
    //   console.log(this.CountryData);

    //   //Add Cities to CityData List
    //   for(var i=0;i<this.MasterList.length;i++){
    //     this.MasterList[i].cityList.forEach(element => {
    //       var _cy = new city();
    //       _cy.cityId = element.cityID;
    //       _cy.cityName = element.cityName;
    //       _cy.countryId = element.countryID;

    //       this.cityData.push(_cy);
    //     })
    //   }

    //   console.log(this.cityData);

    //   this.CountrySelected=this.cityData.find(x=>x.cityId==this.selectedCity.cityID).countryId;

    //   this.CitySelected= this.selectedCity.cityID;
    //   this.CityName = this.selectedCity.cityName;
    //   this.countryName = this.selectedCity.countryName;

    //   if(this.selectedCity.isActive){
    //       this.selectActiveStatus.isChecked=true;
    //   }
    //   else{
    //     this.selectInActiveStatus.isChecked=true;
    //   }
    // }, 1000);
  
  }

  showBtn(){
    if(this.CityName !== '' || this.CityName.length != 0){
      return false;
    }
    return true;
  }

  setOldValues(){
    this.oldValues.isActive = this.selectedCity.isActive == true ? "true" : "false";
    this.oldValues.cityName = this.selectedCity.cityName;
    this.oldValues = Object.keys(this.oldValues).map(key => ({Name: key, Value: this.oldValues[key]}));
  }

  setNewValues(cityName: string){
    this.newValues.isActive = this.Status == true ? "true" : "false";
    this.newValues.cityName = cityName;
    this.newValues = Object.keys(this.newValues).map(key => ({Name: key, Value: this.newValues[key]}));
  }

  convertToIST(date: any){
    date.setHours(date.getHours() + 5);
    date.setMinutes(date.getMinutes() + 30);
    var isodate = date.toISOString();

    return isodate;
  }

  saveToAuditTrail(cityName: string, changedBy: string){
    this.setOldValues();
    this.setNewValues(cityName);

    let auditData: AuditTrail = new AuditTrail();
    auditData.changedBy = changedBy;
    auditData.actionPerformed = "Update";
    auditData.actionPerformedOn = "City";
    auditData.primaryKey = this.selectedCity.cityName;
    auditData.dateChanged = this.convertToIST(new Date());
    
    let auditText: Array<AuditData> = new Array<AuditData>();

    this.oldValues.forEach(oldValues => {
      this.newValues.forEach(newValues => {
        if(oldValues.Name == newValues.Name){
          if(oldValues.Value != newValues.Value){
            var obj : AuditData = new AuditData();
            obj.changedAttribute = oldValues.Name;
            obj.oldValue = oldValues.Value;
            obj.newValue = newValues.Value;
            auditText.push(obj);
          }
        }
      })
    })

    auditData.messageText = auditText;
    this.auditResult = auditData;
  }

   EditCity(city)
  {
    // console.log(city)
    // this._masterService.getMastersData()
    // .pipe(takeUntil(this.unsubscribe$))
    // .subscribe((data) => {
    //   this.MasterList = data;
    //   this.cityData = this.MasterList.city;
    // })
    if(this.selectActiveStatus.isChecked){
      this.Status=true;
    }
    else{
      this.Status=false;
    }
   
    var username = localStorage.getItem('email');

    this.saveToAuditTrail(city,username);

   let params = {
     cityID : this.selectedCity.cityID,
     cityName : city,
     cityId :this.CitySelected,
     countryID: this.selectedCity.countryID,
     countryName : this.countryName,
     changedBy: username,
     addedBy: this.selectedCity.addedBy,
     dateAdded: this.selectedCity.dateAdded,
     isActive:this.Status
    };

   this._dataContextService.postDatawithValues<any>(this.service_URL.CityDetails.EditCity,params)
   .pipe(takeUntil(this.unsubscribe$))
   .subscribe(res => {      

        if(res == 1)
        {
  
          this.toast.success("Successfully updated City details!");
          
        } 
        else if(res == 0)
        {
          this.toast.error("Some thing went on wrong..");
        }
        else if (res == 2) {
          this.toast.error("City details are already exist in this City");
        }
       
       // ToastrComponent.success("Successfully updated office details!");
   },
   (err) => {
    console.log(err);
   },
   () => {
      //Saving Data in Audit Trail
    let auditParams = {
      actionPerformed : this.auditResult.actionPerformed,
      actionPerformedOn : this.auditResult.actionPerformedOn,
      changedBy : this.auditResult.changedBy,
      dateChanged : this.auditResult.dateChanged,
      primaryKey : this.auditResult.primaryKey,
      messageText : this.auditResult.messageText
    };

    let tokenNew = localStorage.getItem('accessToken');
  var headers=new HttpHeaders({ 
    'Authorization' : `Bearer ${tokenNew}`
  })
  this.http.post<any>(this.service_URL.AuditTrail.saveconfigaudittrail, auditParams,{headers:headers})
    .subscribe(res => { 
      console.log(res);
    },
    (err)=>{
      console.log(err);
    },
    ()=>{
      this.citiesService.refreshwithFilters.next();
      this.modalRef.hide();
    }
    );
    
    /*this._dataContextService.postDatawithValues<any>(this.service_URL.AuditTrail.saveconfigaudittrail,auditParams)
    .pipe(takeUntil(this.unsubscribe$))
    .subscribe((res) => {
      //console.log(res);
    })*/

   })   
  }
  getData(){
    //CityMasterData API/
    this._masterService.getCityMasterData()
    .pipe(takeUntil(this.unsubscribe$))
    .subscribe((data) => {
      this.MasterList = data;
      this.CityList=data;
    })
  }

  ngOnDestroy(){
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
